import React, { FC, useEffect, useState } from 'react'
import { ICalcs } from '../../../models/IUserCalc/ICalcs'
import CalcCard from './CalcCard'
import Emptiness from '../../../components/UI/emptiness/Emptiness'
import Timofey from "../../../assets/images/Timofey_avatar.png";
interface IUserCalc {
  value: string,
  data: ICalcs
}

const UserCalcs: FC<IUserCalc> = ({ data }) => {
  const [calc, setCalcs] = useState<any>([])

  useEffect(() => {
    if (data !== undefined) {
      const filtered = Object.entries(data).filter(item => item[1].length > 0) // show only non-empty calculations
      setCalcs(filtered)
    }
  }, [data])
  
  return (
    <section className="section">
      <div className="section-title">User calculations</div>
      {data !== undefined && Object.values(data).every(item => item.length > 0) ?
        <div className="section-main calc" >
          {calc.map((item: any) => (
            <CalcCard calcType={item[0]} data={item[1]} key={item[0]} />
          ))}
        </div>
        :
        <div className="section-main calc" style={{ gridTemplateColumns: "none" }}><Emptiness icon={Timofey} content="There are no user calculations" /></div>
      }
    </section >
  );
}

export default UserCalcs